<template>
  <div :class="`${isCard ? 'card-body' : ''} px-0`">
    <table class="table">
      <tbody>
        <tr class="" v-for="(data, index) in getInfoColumns()" :key="index">
          <td
            v-if="isShowTd(data.showInDialog)"
            :style="{
              ...getBackgroundStyle(infoData[data.prop]),
              wordBreak: 'auto-phrase',
              textAlign: 'justify',
            }"
          >
            <h6 class="mb-1">
              <strong>{{ data.label }}:</strong>
            </h6>
            <span v-if="validateIsset(data.prop)" class="mt-2">
              <template v-if="data.colors">
                <div :style="getBackgroundStyle(infoData[data.prop])">
                  {{ infoData[data.prop].color }}
                </div>
              </template>
              <template v-else-if="data.image">
                <image-with-zoom
                  :urlFile="infoData[data.prop]"
                  :diskName="infoData.disk"
                />
              </template>
              <template v-else-if="data.showMap">
                <div ref="map" class="map" style="height: 400px"></div>
              </template>
              <template v-else-if="data.mgmtRoles">
                <management-roles-dialog :rowData="infoData" />
              </template>
              <template v-else-if="data.lots">
                <lots-info-dialog :rowData="infoData" /> </template
              ><template v-else-if="data.packingHouses">
                <packing-houses-dialog :rowData="infoData" />
              </template>
              <template v-else-if="data.activityGroup">
                <span
                  v-for="(activity, index) in infoData.activities"
                  :key="index"
                >
                  <activities-tag :activity="activity" class="mt-2" />
                </span>
              </template>
              <template v-else-if="data.articleCategory">
                <span
                  v-for="(article, index) in infoData.articles"
                  :key="index"
                >
                  <articles-tag :article="article" class="mt-2" />
                </span>
              </template>
              <template v-else-if="data.providerContact">
                <span
                  v-for="(contact, index) in infoData.provider_contacts"
                  :key="index"
                >
                  <contacts-tag :contact="contact" class="mt-2" />
                </span>
              </template>
              <template v-else-if="data.providers">
                <span
                  v-for="(provider, index) in infoData.provider_headers"
                  :key="index"
                >
                  <provider-tag :provider="provider" class="mt-2" />
                </span>
              </template>
              <template v-else>
                <template
                  v-if="data.formatter && typeof data.formatter === 'object'"
                >
                  <template v-if="validateTypeFormatter(data.formatter)">
                    <div
                      v-if="data.formatter"
                      :is="data.formatter"
                      :row="infoData"
                      :column="data.prop"
                    ></div>
                  </template>
                </template>
                <template v-else-if="data.formatter">
                  {{ data.formatter(infoData, { property: data.prop }) }}
                </template>
                <template v-else>
                  {{ getValue(data.prop) }}
                </template>
              </template>
            </span>
            <el-tag
              v-else
              type="warning"
              :effect="infoData.effectTags"
              class="mt-2"
              >{{ $t('common_words.no_assignment') }}</el-tag
            >
          </td>
        </tr>
        <slot name="addColumn"></slot>
        <tr class="" v-if="showBusinesses">
          <td-info-tag
            :data="infoData.businesses"
            :tdLabel="`${$t('common_words.associated_companies')}:`"
            :fieldTag="labelTags.businesses"
            :effect="infoData.effectTags"
          />
        </tr>
        <tr class="" v-if="showModules">
          <td-info-tag
            :data="infoData.modules"
            :tdLabel="`${$t('common_words.modules')}:`"
            :fieldTag="labelTags.modules"
            :effect="infoData.effectTags"
          />
        </tr>
        <tr class="" v-if="showSubcategories">
          <td-info-tag
            :data="infoData.subcategories"
            :tdLabel="`${$t('common_words.sub_category')}:`"
            :fieldTag="labelTags.subcategories"
            :effect="infoData.effectTags"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import ActivitiesTag from 'src/views/Pages/Dashboard/Work/ActivitiesGroups/ActivitiesTag.vue';
import AddressFormatter from 'src/components/Layouts/AddressFormatter';
import ArticlesTag from 'src/views/Pages/Dashboard/Supplying/Inventory/ArticleCategory/ArticlesTag.vue';
import ImageWithZoom from '../ImageWithZoom.vue';
import LotsInfoinDialog from 'src/views/Pages/Dashboard/Farm/LotsInfoinDialog.vue';
import ManagementRolesinDialog from 'src/views/Pages/Dashboard/Farm/ManagementRolesinDialog.vue';
import MapService from 'src/class/MapService.js';
import PackingHousesinDialog from 'src/views/Pages/Dashboard/Farm/PackingHousesinDialog.vue';
import ProviderContactsTag from 'src/views/Pages/Dashboard/Supplying/Inventory/Provider/ProviderContactsTag.vue';
import ProvidersTag from 'src/views/Pages/Dashboard/Supplying/Inventory/Supplying/ProvidersTag.vue';
import TdInfoTag from './TdInfoTag.vue';

export default {
  name: 'info-table',
  components: {
    [ActivitiesTag.name]: ActivitiesTag,
    [ArticlesTag.name]: ArticlesTag,
    [AddressFormatter.name]: AddressFormatter,
    [ImageWithZoom.name]: ImageWithZoom,
    [LotsInfoinDialog.name]: LotsInfoinDialog,
    [ManagementRolesinDialog.name]: ManagementRolesinDialog,
    [PackingHousesinDialog.name]: PackingHousesinDialog,
    [ProviderContactsTag.name]: ProviderContactsTag,
    [ProvidersTag.name]: ProvidersTag,
    [TdInfoTag.name]: TdInfoTag,
  },
  data() {
    return {
      map: null,
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
    };
  },
  props: {
    labelTags: {
      type: Object,
      default: () => ({
        businesses: 'name',
        modules: 'name',
        subcategories: 'name',
      }),
    },
    infoColumns: {
      type: Array,
      default: () => [],
    },
    infoData: {
      type: Object,
      default: () => ({}),
    },
    showBusinesses: {
      type: Boolean,
      default: false,
    },
    showModules: {
      type: Boolean,
      default: false,
    },
    showSubcategories: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    validateTypeFormatter(value) {
      if (typeof value !== 'function') {
        return true;
      }

      return false;
    },
    getValue(dataProp) {
      if (dataProp.includes('.')) {
        const objectPath = dataProp.split('.');
        let response = this.infoData;
        objectPath.forEach((propertyName) => {
          response = response ? response[propertyName] : null;
        });

        return response ? response : null;
      } else return this.infoData[dataProp];
    },
    validateIsset(dataProp) {
      const value = this.getValue(dataProp);
      switch (typeof value) {
        case 'number':
          return isset(Number(value));

        default:
          return isset(value);
      }
    },
    getInfoColumns() {
      return this.infoColumns.filter(
        (column) => column.toShow || typeof column.toShow == 'undefined'
      );
    },
    getBackgroundStyle(data) {
      let style = {};
      if (data && data.color && data.color_text) {
        style.backgroundColor = data.color;
        style.color = data.color_text;
      }
      return style;
    },
    isShowTd(show) {
      if (typeof show === 'undefined') return true;
      else if (typeof show !== 'undefined' || show !== null) return show;
    },
  },
  mounted() {
    if (this.infoData.methodMap) {
      this.center = {
        lat: this.infoData.latitude
          ? parseFloat(this.infoData.latitude.replace(',', '.'))
          : this.center.lat,
        lng: this.infoData.longitude
          ? parseFloat(this.infoData.longitude.replace(',', '.'))
          : this.center.lng,
      };

      if (this.infoData.methodMap === 'loadBaseMap')
        MapService.loadBaseMap(this.infoData.id, this);
    }
  },
};
</script>
